/** Keep the legacy wordmark on its own hostname. */

import { PORTAL_BRAND } from '../../config/branding';

export function BrandWordmark() {
  if (PORTAL_BRAND.id === 'eleet') {
    return (
      <>
        <span style={{ color: '#0DB5D0' }}>eleet</span>
        <span style={{ color: 'hsl(var(--color-neutral-400))' }}>.ai</span>
      </>
    );
  }
  return <span style={{ color: 'hsl(var(--color-primary-700))' }}>{PORTAL_BRAND.shortName}</span>;
}
